import {
  capitalize,
  orderBy,
} from 'lodash';

export function stringsToOptions(vals){
  let arr;
  if (!Array.isArray(vals)) {
    arr = [vals];
  } else {
    arr = vals;
  }

  return arr.map((val)=>{
    if (typeof val === 'string' || val instanceof String) {
      return { label: capitalize(val), key: val, value: val }
    } else {
      return val
    }
  });
}

export function toInt(val){
  const intVal = parseInt(val, 10);
  return isNaN(intVal) ?  val : intVal;
}

export function arrayToObject(array, keyField, sortField){
  let source

  if (sortField !== undefined) {
    source = orderBy(array, sortField);
  } else {
    source = array;
  }
  return source.reduce((obj, item) => {
    obj[item[keyField]] = item
    return obj
  }, {});
}



// WEBPACK FOOTER //
// ./src/lib/helpers.js